package org.hs_soft.runmynesto.domain.model.home.statistic.tabs.search_bill

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.jetbrains.compose.web.css.CSSColorValue


enum class BillSearchDetailTableHeadersEnum(
    val key: String,
    val isNumeric: Boolean = false,
) {
    ITEMS(
        key = "",
    ),
    NAME(
        key = "name"
    ),
    AMOUNT(
        key = "amount",
        isNumeric = true,
    ),
    PERCENT(
        key = "percent",
        isNumeric = true,
    ),
    VAT(
        key = "vat"
    ),
    IN_HOUSE(
        key = "isInHouse",
        isNumeric = true,
    ),
    TOTAL(
        key = "total",
        isNumeric = true,
    ),;
//    NUMBER(
//        key = "number"
//    ),
//    PRICE(
//        key = "price",
//        isNumeric = true,
//    ),;



    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                AMOUNT -> strings.amount
                ITEMS->strings.items
//                NUMBER -> strings.number
                NAME -> strings.name
//                PRICE -> strings.price
                PERCENT -> strings.percentSign
                VAT -> strings.vat
                IN_HOUSE -> strings.inTheHouse
                TOTAL -> strings.total
            }
        }
}